import { render, staticRenderFns } from "./TrocarSenha.vue?vue&type=template&id=5b32476f&scoped=true&"
import script from "./TrocarSenha.vue?vue&type=script&lang=js&"
export * from "./TrocarSenha.vue?vue&type=script&lang=js&"
import style0 from "./TrocarSenha.vue?vue&type=style&index=0&id=5b32476f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32476f",
  null
  
)

export default component.exports